import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';
import NextLink from 'components/NextLink';

import styles from './styles.module.scss';

const Item = forwardRef(({ title, path, mode = 'mobile', tabIndex }, ref) => {
	const itemCx = cx(styles.BreadcrumbsItem, styles[`BreadcrumbsItem_${mode}`], {
		[styles.BreadcrumbsItem_hasLink]: !!path
	});
	const url = path && `/${path}`;

	return (
		<div className={itemCx}>
			{url ? (
				<NextLink
					href={url}
					className={styles.BreadcrumbsItem__Link}
					ref={ref}
					tabIndex={tabIndex}
					role="link"
				>
					{title}
				</NextLink>
			) : (
				title
			)}
			<Icon
				icon="chevronRight"
				className={styles.BreadcrumbsItem__Icon}
				aria-hidden
			/>
		</div>
	);
});

Item.propTypes = {
	title: PropTypes.string.isRequired,
	path: PropTypes.string,
	mode: PropTypes.oneOf(['mobile', 'desktop']),
	tabIndex: PropTypes.number
};

export default Item;
